/**
 * Metric tone — Tailwind text-color class per metric semantics + value.
 *
 * Drives the "logical colors" UX: profit & ROI swing green/red, cost glows
 * amber when positive (you're spending), revenue/earnings turn green when
 * non-zero, conversion volumes lift to green when there's traffic. Everything
 * else stays neutral so the eye is drawn to what actually matters.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

const POS_GREEN = 'text-emerald-600 dark:text-emerald-400';
const NEG_RED = 'text-rose-600 dark:text-rose-400';
const COST_AMBER = 'text-amber-600 dark:text-amber-400';
const NEUTRAL = 'text-foreground';
const MUTED = 'text-muted-foreground';

const SIGNED_IDS = new Set(['profit', 'roi']);
const REVENUE_IDS = new Set(['revenue', 'epc', 'epl', 'uEPC', 'epv', 'rpm']);
const COST_IDS = new Set(['cost', 'cpc', 'cpv', 'ecpa', 'ecpm', 'CPL', 'CPS']);
const CONVERSION_IDS = new Set([
  'conversions',
  'registrations',
  'ftd',
  'customConversions6',
  'customConversions7',
]);

export function metricTone(id: string, value: number): string {
  if (!Number.isFinite(value)) return MUTED;
  if (SIGNED_IDS.has(id)) {
    if (value > 0) return POS_GREEN;
    if (value < 0) return NEG_RED;
    return NEUTRAL;
  }
  if (REVENUE_IDS.has(id)) return value > 0 ? POS_GREEN : NEUTRAL;
  if (COST_IDS.has(id)) return value > 0 ? COST_AMBER : NEUTRAL;
  if (CONVERSION_IDS.has(id)) return value > 0 ? POS_GREEN : MUTED;
  return NEUTRAL;
}

export function rawScoreTone(value: number): string {
  if (!Number.isFinite(value)) return MUTED;
  if (value > 0) return POS_GREEN;
  if (value < 0) return NEG_RED;
  return NEUTRAL;
}
